import { EventEntity } from 'stores/common';
import { TableRowEntityType } from 'stores/local/forms/types';

export enum EditFormStoreEventKind {
  ROW_CLICK = 'FORM_CREATE/TABLE_ROW_CLICK',
  SETUP_BUTTON_CLICK = 'FORM_CREATE/SETUP_BUTTON_CLICK',
  SET_HIGHLIGHTED_ROWS = 'F0RM_CREATE/SET_HIGHLIGHTED_ROWS',
  TOGGLE_SETTINGS_DRAWER = 'FORM_CREATE/TOGGLE_SETTINGS_DRAWER',
}

export type EditFormStoreRowClickEvent = EventEntity<
  EditFormStoreEventKind.ROW_CLICK,
  TableRowEntityType
>;

export type EditFormStoreSetupButtonClickEvent = EventEntity<
  EditFormStoreEventKind.SETUP_BUTTON_CLICK,
  TableRowEntityType
>;

export type EditFormStoreSetHighlightedRowsEvent = EventEntity<
  EditFormStoreEventKind.SET_HIGHLIGHTED_ROWS,
  {
    rows: string[];
  }
>;

export type EditFormStoreToggleSettingsDrawerEvent = EventEntity<
  EditFormStoreEventKind.TOGGLE_SETTINGS_DRAWER,
  {
    payload: boolean;
  }
>;

export type EditFormStoreEvent =
  | EditFormStoreRowClickEvent
  | EditFormStoreSetupButtonClickEvent
  | EditFormStoreToggleSettingsDrawerEvent
  | EditFormStoreSetHighlightedRowsEvent;

export function isEditFormStoreRowClickEvent(
  entity: EventEntity
): entity is EditFormStoreRowClickEvent {
  return entity.kind === EditFormStoreEventKind.ROW_CLICK;
}

export function isEditFormStoreSetupButtonClickEvent(
  entity: EventEntity
): entity is EditFormStoreSetupButtonClickEvent {
  return entity.kind === EditFormStoreEventKind.SETUP_BUTTON_CLICK;
}

export function isEditFormStoreSetHighlightedRowsEvent(
  entity: EventEntity
): entity is EditFormStoreSetHighlightedRowsEvent {
  return entity.kind === EditFormStoreEventKind.SET_HIGHLIGHTED_ROWS;
}

export function isEditFormStoreToggleSettingsDrawerEvent(
  entity: EventEntity
): entity is EditFormStoreToggleSettingsDrawerEvent {
  return entity.kind === EditFormStoreEventKind.TOGGLE_SETTINGS_DRAWER;
}
